import React, { useReducer } from 'react';

import {
  GlobalStateContext,
  GlobalState,
  initialState,
} from 'contexts/globalState';

const rootReducer = (state: GlobalState, { type, payload }) => {
  switch (type) {
    case 'SET_CURRENCY':
      return {
        ...state,
        currency: payload,
      };
    case 'SET_LOCALE':
      return {
        ...state,
        locale: payload,
      };
    default:
      return state;
  }
};

const GlobalStateProvider = ({ children }: { children?: React.ReactNode }) => {
  const [state, dispatch] = useReducer(rootReducer, initialState);

  return (
    <GlobalStateContext.Provider value={[state, dispatch]}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export default GlobalStateProvider;
